.columnLayout {
	@apply
	yst-flex
	yst-flex-col
	yst-gap-6;
}

.firstColumn {
	@apply
	yst-flex
	yst-flex-col
	yst-gap-4
	yst-items-center
	yst-justify-center
	yst-text-center;

	:global(.asideLogo) {
		@apply
		yst-w-full;
	}

	:global(.asideIcon) {
		@apply
		yst-hidden;
	}
}

.linkColumn {
	@apply
	yst-text-right;
}
